type SliceModule = {
  initialState: unknown;
  slice: { name: string; [key: string]: unknown };
};

const allSlices: Record<string, SliceModule['slice']> = {};
const initialState: Record<string, unknown> = {};

function importAll(r: Record<string, SliceModule>) {
  Object.entries(r).forEach(([, module]) => {
    const { initialState: sliceInitialState, slice } = module;

    initialState[slice.name] = sliceInitialState;
    allSlices[slice.name] = slice;
  });
}

importAll(
  import.meta.glob<SliceModule>('./**/*-slice.{js,ts}', { eager: true })
);

export { allSlices, initialState };
